// ===========================================
// SCHEMA: PlanPago
// ===========================================
// Schema Zod para el formulario de marcar plan de pago

import { z } from 'zod'

export const planPagoSchema = z.object({
  cuotas: z.number().int().min(1, 'Debe tener al menos 1 cuota').max(120, 'Máximo 120 cuotas').nullable().optional(),
  referencia: z.string().nullable().optional(),
  observaciones: z.string().nullable().optional(),
})

export type PlanPagoFormValues = z.infer<typeof planPagoSchema>
